
<template>
  <div class="ma-3 text-xs-center">
    <h1 class="mt-3 mb-3">Artists</h1>
    <div v-for="artist in artists()" v-bind:key="artist">
      <ArtistDetails :artist="artist"></ArtistDetails>
      <v-divider class="mt-2 mb-5"></v-divider>
    </div>
    
    <h4 class="mt-3 mb-3">Other Free Downloads</h4>
    (subject to change)
    <v-container class="pa-0 justify-center">
      <v-layout row wrap class="justify-center">
        <v-card
          style="float: left; border-color: black"
          v-for="infoItem in freeMusic()"
          v-bind:key="infoItem"
          class="ma-2 pa-2"
        >
          <FreeMusicItem :infoItem="infoItem"></FreeMusicItem>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import artists from "../data/artist-data";
import freeMusic from "../data/free-downloads";
import ArtistDetails from "./ArtistDetails.vue";
import FreeMusicItem from "./FreeMusicItem.vue";

export default {
  name: "Music",
  methods: {
    freeMusic() {
      return freeMusic;
    },
    artists() {
      return artists;
    },
  },
  components: {
    ArtistDetails,
    FreeMusicItem
  },
  data: () => ({}),
};
</script>

<style scoped>
.v-card {
  display: block;
  width: 300px;
  height: auto;
  overflow: auto;
}

.artistImage {
  max-width: 200px;
}
</style>